import Vue from 'vue'
import Router from 'vue-router'

import index from '@/pages/index'
import about from '@/pages/about'
import help from '@/pages/help'
import helpDetail from '@/pages/helpDetail'
import rule from '@/pages/rule'
import downLoad from '@/pages/downLoad'
import language from '@/pages/language'
import quicklyBuyCoins from '@/pages/quicklyBuyCoins'
import quicklyBuyCoinsDetail from '@/pages/quicklyBuyCoinsDetail'
import credit from '@/pages/credit'
import reg from '@/pages/reg'
import login from '@/pages/login'
import notice from '@/pages/notice'
import bannerDetail from '@/pages/bannerDetail'
import forgetPwd from '@/pages/forgetPwd'
import city from '@/pages/city'
import agreement from '@/pages/agreement' //贷币协议
import agreementApp from '@/pages/agreementApp'
import modifyPwd from '@/pages/modifyPwd'
import setWithdrawPwd from '@/pages/setWithdrawPwd'
import accountRecords from '@/pages/accountRecords'
import primaryCertification from '@/pages/primaryCertification' //初级认证
import advancedCertification from '@/pages/advancedCertification' //高级认证
import authentication from '@/pages/authentication' //身份认证

import user from '@/pages/user'
import set from '@/pages/set'
import records from '@/pages/records' //充币记录
import withdrawRecords from '@/pages/withdrawRecords' //提币记录
import securityCenter from '@/pages/securityCenter'
import quotes from '@/pages/quotes' //行情
import currencyTrading from '@/pages/currencyTrading' //币币交易
import contractTransaction from '@/pages/contractTransaction' //合约交易
import myAssets from '@/pages/myAssets'
import deposit from '@/pages/deposit' //充币
import withdraw from '@/pages/withdraw' //提币
import selectCurrency from '@/pages/selectCurrency' //选择币种
import propagate from '@/pages/propagate' //持币生息
import propagateBuy from '@/pages/propagateBuy' //持币生息购买
import currency from '@/pages/currency' //贷币
import currencyRecord from '@/pages/currencyRecord' //贷币
import userAgreement from '@/pages/userAgreement' //用户协议
import userAgreementApp from '@/pages/userAgreementApp' //用户协议
import repayment from '@/pages/repayment'
import repayment2 from '@/pages/repayment2'
import subscription from '@/pages/subscription' //新币申购
import subscribe from '@/pages/subscribe' //新币申购
import subscriptionList from '@/pages/subscriptionList' //新币申购
import orderStatus from '@/pages/orderStatus' //持币生息订单状态
import perpetualContract from '@/pages/perpetualContract' //永续合约
import kline from '@/pages/kline'
import positionList from '@/pages/positionList' //持仓列表
import delegateList from '@/pages/delegateList' //委托列表
import bindMail from '@/pages/bindMail' //邮箱认证
import security from '@/pages/security' //密保问题
import securityModPwd from '@/pages/securityModPwd' //密保问题修改密码
import addressAuth from '@/pages/addressAuth' //地址认证
import profitLoss from '@/pages/profitLoss' //止盈止损
import quickReg from '@/pages/quickReg' //快捷注册
import selectPropagateCurrency from '@/pages/selectPropagateCurrency' //选择持币生息币种
import service from '@/pages/service' //客服

import capital from '@/pages/capital/capital' //验资
import results from '@/pages/capital/results' //结果
import verification from '@/pages/capital/verification' //验资
import sign from '@/pages/sign' //签到
import signRule from '@/pages/signRule' //签到规则
import benefits from '@/pages/benefits' //福利专区
import benefitsDetail from '@/pages/benefitsDetail' //福利专区

import preciousMetal from '@/pages/preciousMetal' //贵金属
import trading from '@/pages/trading' //贵金属交易大厅
import contractOrder from '@/pages/contractOrder' //贵金属订单
import setProfit from '@/pages/setProfit' //贵金属设置止盈止损
import contractTransaction2 from '@/pages/contractTransaction2' //贵金属交割
import positionList2 from '@/pages/positionList2' //贵金属交割列表
import depositTips from '@/pages/depositTips' //充值提示


Vue.use(Router)

export default new Router({
  linkActiveClass:'active',
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: resolve =>(require(["@/pages/index"],resolve)),
      meta: {
        // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/index',
      name: 'index',
      component: resolve =>(require(["@/pages/index"],resolve)),
      meta: {
        // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/about',
      name: 'about',
      component: resolve =>(require(["@/pages/about"],resolve)),
    },
    {
      path: '/help',
      name: 'help',
      component: resolve =>(require(["@/pages/help"],resolve)),
    },
    {
      path: '/helpDetail',
      name: 'helpDetail',
      component: resolve =>(require(["@/pages/helpDetail"],resolve)),
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule,
    },
    {
      path: '/downLoad',
      name: 'downLoad',
      component: resolve =>(require(["@/pages/downLoad"],resolve)),
    },
    {
      path: '/language',
      name: 'language',
      component: resolve =>(require(["@/pages/language"],resolve)),
    },
    {
      path: '/city',
      name: 'city',
      component: resolve =>(require(["@/pages/city"],resolve)),
    },
    {
      path: '/quicklyBuyCoins',
      name: 'quicklyBuyCoins',
      component: resolve =>(require(["@/pages/quicklyBuyCoins"],resolve)),
    },
    {
      path: '/quicklyBuyCoinsDetail',
      name: 'quicklyBuyCoinsDetail',
      component: resolve =>(require(["@/pages/quicklyBuyCoinsDetail"],resolve)),
    },
    {
      path: '/credit',
      name: 'credit',
      component: resolve =>(require(["@/pages/credit"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve =>(require(["@/pages/login"],resolve)),
    },
    {
      path: '/reg',
      name: 'reg',
      component: resolve =>(require(["@/pages/reg"],resolve)),
    },
    {
      path: '/quickReg',
      name: 'quickReg',
      component: resolve =>(require(["@/pages/quickReg"],resolve)),
    },
    {
      path: '/notice',
      name: 'notice',
      component: resolve =>(require(["@/pages/notice"],resolve)),
    },
    {
      path: '/bannerDetail',
      name: 'bannerDetail',
      component: resolve =>(require(["@/pages/bannerDetail"],resolve)),
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: resolve =>(require(["@/pages/forgetPwd"],resolve)),
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: resolve =>(require(["@/pages/agreement"],resolve)),
    },
    {
      path: '/agreementApp',
      name: 'agreementApp',
      component: resolve =>(require(["@/pages/agreementApp"],resolve)),
    },
    {
      path: '/modifyPwd',
      name: 'modifyPwd',
      component: resolve =>(require(["@/pages/modifyPwd"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/setWithdrawPwd',
      name: 'setWithdrawPwd',
      component: resolve =>(require(["@/pages/setWithdrawPwd"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/accountRecords',
      name: 'accountRecords',
      component: resolve =>(require(["@/pages/accountRecords"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/primaryCertification',
      name: 'primaryCertification',
      component: resolve =>(require(["@/pages/primaryCertification"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/advancedCertification',
      name: 'advancedCertification',
      component: resolve =>(require(["@/pages/advancedCertification"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/authentication',
      name: 'authentication',
      component: resolve =>(require(["@/pages/authentication"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: resolve =>(require(["@/pages/user"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/set',
      name: 'set',
      component: resolve =>(require(["@/pages/set"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/records',
      name: 'records',
      component: resolve =>(require(["@/pages/records"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/withdrawRecords',
      name: 'withdrawRecords',
      component: resolve =>(require(["@/pages/withdrawRecords"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/securityCenter',
      name: 'securityCenter',
      component: resolve =>(require(["@/pages/securityCenter"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: resolve =>(require(["@/pages/quotes"],resolve)),
    },
    {
      path: '/currencyTrading',
      name: 'currencyTrading',
      component: resolve =>(require(["@/pages/currencyTrading"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractTransaction',
      name: 'contractTransaction',
      component: resolve =>(require(["@/pages/contractTransaction"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/myAssets',
      name: 'myAssets',
      component: resolve =>(require(["@/pages/myAssets"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: resolve =>(require(["@/pages/withdraw"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/deposit',
      name: 'deposit',
      component: resolve =>(require(["@/pages/deposit"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/selectCurrency',
      name: 'selectCurrency',
      component: resolve =>(require(["@/pages/selectCurrency"],resolve)),
    },
    {
      path: '/propagate',
      name: 'propagate',
      component: resolve =>(require(["@/pages/propagate"],resolve)),
    },
    {
      path: '/currency',
      name: 'currency',
      component: resolve =>(require(["@/pages/currency"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/currencyRecord',
      name: 'currencyRecord',
      component: resolve =>(require(["@/pages/currencyRecord"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: resolve =>(require(["@/pages/userAgreement"],resolve)),
    },
    {
      path: '/userAgreementApp',
      name: 'userAgreementApp',
      component: resolve =>(require(["@/pages/userAgreementApp"],resolve)),
    },
    {
      path: '/repayment',
      name: 'repayment',
      component: resolve =>(require(["@/pages/repayment"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/repayment2',
      name: 'repayment2',
      component: resolve =>(require(["@/pages/repayment2"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/subscription',
      name: 'subscription',
      component: resolve =>(require(["@/pages/subscription"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: resolve =>(require(["@/pages/subscribe"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/subscriptionList',
      name: 'subscriptionList',
      component: resolve =>(require(["@/pages/subscriptionList"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/orderStatus',
      name: 'orderStatus',
      component: resolve =>(require(["@/pages/orderStatus"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/propagateBuy',
      name: 'propagateBuy',
      component: resolve =>(require(["@/pages/propagateBuy"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/perpetualContract',
      name: 'perpetualContract',
      component: resolve =>(require(["@/pages/perpetualContract"],resolve)),
    },
    {
      path: '/kline',
      name: 'kline',
      component: resolve =>(require(["@/pages/kline"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/positionList',
      name: 'positionList',
      component: resolve =>(require(["@/pages/positionList"],resolve)),
    },
    {
      path: '/delegateList',
      name: 'delegateList',
      component: resolve =>(require(["@/pages/delegateList"],resolve)),
    },
    {
      path: '/bindMail',
      name: 'bindMail',
      component: resolve =>(require(["@/pages/bindMail"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/security',
      name: 'security',
      component: resolve =>(require(["@/pages/security"],resolve)),
    },
    {
      path: '/securityModPwd',
      name: 'securityModPwd',
      component: resolve =>(require(["@/pages/securityModPwd"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/addressAuth',
      name: 'addressAuth',
      component: resolve =>(require(["@/pages/addressAuth"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/profitLoss',
      name: 'profitLoss',
      component: resolve =>(require(["@/pages/profitLoss"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/selectPropagateCurrency',
      name: 'selectPropagateCurrency',
      component: resolve =>(require(["@/pages/selectPropagateCurrency"],resolve)),
    },
    {
      path: '/service',
      name: 'service',
      component: resolve =>(require(["@/pages/service"],resolve)),
    },
    {
      path: '/capital',
      name: 'capital',
      component: resolve =>(require(["@/pages/capital/capital"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/results',
      name: 'results',
      component: resolve =>(require(["@/pages/capital/results"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/verification',
      name: 'verification',
      component: resolve =>(require(["@/pages/capital/verification"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/sign',
      name: 'sign',
      component: resolve =>(require(["@/pages/sign"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/signRule',
      name: 'signRule',
      component: resolve =>(require(["@/pages/signRule"],resolve)),
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: resolve =>(require(["@/pages/benefits"],resolve)),
    },
    {
      path: '/benefitsDetail',
      name: 'benefitsDetail',
      component: resolve =>(require(["@/pages/benefitsDetail"],resolve)),
    },
    {
      path: '/preciousMetal',
      name: 'preciousMetal',
      component: resolve =>(require(["@/pages/preciousMetal"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/trading',
      name: 'trading',
      component: resolve =>(require(["@/pages/trading"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractOrder',
      name: 'contractOrder',
      component: resolve =>(require(["@/pages/contractOrder"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/setProfit',
      name: 'setProfit',
      component: resolve =>(require(["@/pages/setProfit"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractTransaction2',
      name: 'contractTransaction2',
      component: resolve =>(require(["@/pages/contractTransaction2"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/positionList2',
      name: 'positionList2',
      component: resolve =>(require(["@/pages/positionList2"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/depositTips',
      name: 'depositTips',
      component: resolve =>(require(["@/pages/depositTips"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path:'/',
      redirect:'index'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js